module.exports = __webpack_public_path__ + "img/business_black_36dp.d154685e.svg";